import React from 'react';
import { TextField } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import { connect } from 'react-redux';
import { whiteColor } from "assets/jss/material-kit-pro-react.js";
import history from '../../../../../src/history';
import {
    warningColor,
    title,
    mrAuto,
    mlAuto
} from "assets/jss/material-kit-pro-react.js";
import { loadingPage } from '../../../store/actions';
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import PasswordChecklist from "react-password-checklist"
import Warning from "@material-ui/icons/Warning";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Simplert from 'react-simplert';
import { withRouter } from "react-router-dom";
import $ from 'jquery';
import { compose } from "redux";
import { authController, dataController } from '../../../store/api/api.js';

const useStyles = themse => ({
    title,
    mrAuto,
    mlAuto,
    warning: {
        color: warningColor[0],
    },
    content: {
        paddingBottom: "30px",
        paddingTop: "20px",
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto",
    },
    right: {
        padding: "15px 0",
        margin: "0",
        float: "right",
        "&,& *,& *:hover,& *:focus": {
            color: whiteColor + "  !important",
        },
    },
    closebuttonPopUp: {
        backgroundColor: "#21B6A8", border: "none", color: "white", padding: "15px 28px", textAlign: "center",
        textDecoration: "none", display: "inline-block", margin: "4px 2px", cursor: "pointer"
    },
});




const errorMess = (msg) => toast.error(msg, {
    position: "bottom-right",
    autoClose: 6000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});



class ResetPasswaordInput extends React.Component {

    state = {
        emailAddress: '',
        foundUser: false,
        userModal: [],
        password: '',
        confirmPassword: '',
        pwdtoken: '',
        passwordMacth: false,


        //pop up message
        showAlert: false,
        typeAlert: '',
        titleAlert: '',
        messageAlert: ''
    }

    componentDidMount() {
        try {
            if (this.props.token !== undefined) {
                this.setState({
                    pwdtoken: this.props.token,
                    emailAddress: this.props.userEmail,
                }, () => {
                });
            }
            else {
             /*   history.push('/error-page');*/
                this.props.history.push('/error-page');
            }
        }
        catch (error) {
            /* history.push('/error-page');*/
            this.props.history.push('/error-page');
        };
    }



    updatePasswordValResult = (value) => {
        if (this.state.passwordMacth !== value) {
            this.setState({ passwordMacth: value }, () => {
            });
        }
    }

    handlePaswordChange = (e) => {
        this.setState({ password: e.target.value }, () => {
        });
    }

    handleConfirmPasswordChange = (e) => {
        this.setState({ confirmPassword: e.target.value }, () => {
        });
    }


    displayMessage = (type, title, message) => {
        this.setState({
            showAlert: true,
            typeAlert: type,
            titleAlert: title,
            messageAlert: message
        }, () => {
            window.scrollTo(0, 0);
        });
    }



    handleUpdateClick = () => {

        const { passwordMacth } = this.state;

        if (passwordMacth !== true) {
            errorMess('Please Check the minimum password length, password complexity and password match requirements.');
            return;
        }
        else {
            this.updatePassword()
        }


    }


    handlePopUpMessage = () => {
        this.setState({ showAlert: false }, () => {
            /*            history.push('/Login');*/
           this.props.history.push('/Login');
        });
    }

    async updatePassword() {
        try {

            const { pwdtoken, confirmPassword } = this.state;

            const response = await fetch(authController + 'resetPassword/', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ConfirmationCode: pwdtoken,
                    Password: confirmPassword,
                    EmailAddress: this.props.userEmail
                })
            })
                .then((response) => {
                    if (response.status === 401) {
                        throw new Error("Unauthorised request");
                    }
                    return response;
                })
                .then(res => res.json())
                .catch();


            if (response) {
                this.displayMessage("success", "Password Reset Successfully", 'Your password has been changed successfully. You can now log onto the FP McCann Website');
                return;
            }
            else {
                errorMess('An Error has occurred when attemping to reset password for (' + this.props.userEmail + '). Please contact FP McCann Sales!');
                return;
            }


        }
        catch (e) {
            errorMess('An error occurred, please try again later.');
            return;
        }
    }

    // UI 
    render() {

        const { classes } = this.props;

        let { showAlert, typeAlert, titleAlert, messageAlert } = this.state


        return (
            <div className={classes.content}>
                <div style={{ width: "100%" }}>
                    <div style={{ padding: "10x" }}>
                        <div>

                            <div>
                                <ToastContainer
                                    position="bottom-right"
                                    autoClose={5000}
                                    hideProgressBar={false}
                                    newestOnTop={false}
                                    closeOnClick
                                    rtl={false}
                                    pauseOnFocusLoss
                                    draggable
                                    pauseOnHover
                                />

                            </div>

                            <Simplert
                                style={{
                                    width: '250px;',
                                    overflow: 'auto',
                                    fontWeight: "600px"
                                }}
                                showSimplert={showAlert}
                                type={typeAlert}
                                title={titleAlert}
                                message={messageAlert}
                                onClose={() => this.handlePopUpMessage()}
                                disableOverlayClick={true}
                                customCloseBtnClass={classes.closebuttonPopUp}
                            />

                            <h3 className={classes.title} style={{ borderBottom: "2px dashed grey" }}>
                                <i class="fas fa-unlock-alt"></i>
                                {' '}
                                Reset Password
                            </h3>
                            <SnackbarContent
                                message={
                                    <span style={{ fontSize: "15px" }}>
                                        Hi <u>{this.props.userEmail}</u>, please enter your new password. Make sure that the password meets the password policy requirements. Check the minimum password length, password complexity and password history requirements before updating.

                                    </span>
                                }
                                close
                                color="danger"
                                icon={Warning}

                            />

                            <GridContainer>

                                <GridItem xs={12} sm={6} md={6}>
                                    <PasswordChecklist
                                        rules={["minLength", "specialChar", "number", "capital", "match", "lowercase"]}
                                        minLength={6}
                                        value={this.state.password}
                                        valueAgain={this.state.confirmPassword}
                                        onChange={(isValid) => { this.updatePasswordValResult(isValid) }}
                                        style={{ color: "#151617" }}
                                    />
                                </GridItem>

                                <GridItem xs={12} sm={6} md={6}>
                                </GridItem>

                                <GridItem xs={12} sm={6} md={6} style={{ paddingTop: "20px" }}>
                                    <TextField
                                        id="outlined-password-input"
                                        label="Password"
                                        type="password"
                                        autoComplete="current-password"
                                        placeholder="Password...."
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        value={this.state.password === null ? "" : this.state.password ? this.state.password : ''}
                                        onChange={this.handlePaswordChange}

                                    />

                                </GridItem>

                                <GridItem xs={12} sm={6} md={6} style={{ paddingTop: "20px" }}>
                                    <TextField
                                        id="outlined-password-input"
                                        label="Confirm Password"
                                        type="password"
                                        autoComplete="current-password"
                                        placeholder="Password...."
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        value={this.state.confirmPassword === null ? "" : this.state.confirmPassword ? this.state.confirmPassword : ''}
                                        onChange={this.handleConfirmPasswordChange}

                                    />
                                </GridItem>


                                <GridItem xs={12} sm={12} md={12} style={{ paddingTop: "20px" }}>


                                    <div className={classes.right}>

                                        <Button
                                            style={{

                                                borderRadius: 2,
                                                padding: "16px 20px",
                                                fontSize: "15px"
                                            }}

                                            color="success"
                                            size="lg"
                                            target="_blank"
                                            onClick={this.handleUpdateClick}

                                        >
                                            <i class="fas fa-check"></i>
                                            &nbsp;  Update Password
                                        </Button>
                                    </div>
                                </GridItem>
                            </GridContainer>
                        </div>
                    </div>
                </div>

            </div>)
    };
}



const mapStateToProps = state => {
    return {
        loadingPage: state.userReducer.loadingPage
    };
};

export default compose(withRouter,connect(mapStateToProps, { loadingPage }))(withStyles(useStyles)(ResetPasswaordInput));